/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Loader, NoDataCard } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { ExpandableTable } from '@superops/ui-design-system';
import { useUserGuideContext } from '@nile/client_management/src/Contracts/Components/UserGuidePopup';

const NestedTable = (props) => {
  const { columns, data, emptyState, subRowAccessorkey } = props;

  const [Data, setData] = useState([]);

  const { isVisible } = useUserGuideContext();

  useEffect(() => {
    setData(data);
  }, [data]);

  const headerMap = {
    techGroup: 'entity.technicianGroup',
    technician: 'app.common.technician',
    client: 'common.client'
  };

  const Columns = columns.map((col) => {
    const { Cell, SubCell } = col;
    return {
      ...col,
      SubCell: ({ row }) => {
        return <SubCell row={row} />;
      },
      Cell: (cell) => {
        function handleClick() {
          cell?.row?.toggleRowExpanded();
        }

        return <Cell {...cell} onClick={handleClick} />;
      }
    };
  });

  return (
    <div
      className={`override-expandable-table-header ${isVisible && 'visible'}`}
    >
      <ExpandableTable
        gutter="sm"
        data={Data}
        columns={Columns}
        subRowAccessorkey={subRowAccessorkey}
        emptyState={
          <div className="flex full-height center jcenter mt25 noDataCard">
            <NoDataCard
              imageURL={
                emptyState?.nodataImage
                  ? `url(${emptyState.nodataImage})`
                  : `url(${envConfig.imageRoot}svg/documents-empty-state.svg)`
              }
              text={emptyState?.heading}
              description={emptyState?.description}
            />
          </div>
        }
      />
    </div>
  );
};

export { NestedTable };
